import Research from "./components";

export default Research;